import { zeroAddress } from 'viem'
import type { Asset } from '../types'

export const ETH: Asset = {
  assetAddress: zeroAddress,
  name: 'Ether',
  decimals: 18,
  symbol: 'ETH',
}
